import { parseResponse } from "../../utils/parseResponse";
import { HostChatMessage } from "../../types";
import { myPartiesResponseKeys } from "../responseKeys/responseKeys";

export function parseHostChatMessages(messages: string[]): HostChatMessage[] {
    return messages.map((el) =>
        parseResponse<HostChatMessage>(el, myPartiesResponseKeys.hostChatMessages)
    );
}
